var __jsx = React.createElement;
import React from "react";
import Button from "../common/Button";
import AwesomeIcon from "../AwesomeIcon";
import { faCamera } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import Image from "next/image";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import classNames from "classnames";
import { isWebView } from "../../utils";
function GuidelineModal(_ref) {
  var isVisible = _ref.isVisible,
    onClose = _ref.onClose,
    onAddFile = _ref.onAddFile,
    isGuidelineActive = _ref.isGuidelineActive,
    setIsGuidelineActive = _ref.setIsGuidelineActive;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var carouselImages = [{
    src: "/assets/guidelines/guideline-1.png",
    content: "crop_image.guideline1"
  }, {
    src: "/assets/guidelines/guideline-2.png",
    content: "crop_image.guideline2"
  }, {
    src: "/assets/guidelines/guideline-3.png",
    content: "crop_image.guideline3"
  }];
  if (!isVisible) return;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full h-full overflow-hidden items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("flex-1 text-left w-full px-6 scrollbar-light dark:scrollbar ", {
      "!px-0": isGuidelineActive
    })
  }, !isGuidelineActive ? /*#__PURE__*/React.createElement("p", {
    className: "text-xl"
  }, t("capture_scan")) : /*#__PURE__*/React.createElement("p", {
    className: "text-xl bg-gray-900 px-6 text-gray-100 font-semibold"
  }, t("upload_scan_guidelines")), isGuidelineActive ? /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-900 flex justify-center"
  }, /*#__PURE__*/React.createElement(Image, {
    src: "/assets/guidelines/guidelines.svg",
    alt: "guidelines",
    width: 360,
    height: 2614
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      setIsGuidelineActive(true);
    },
    className: "flex space-x-3 items-center py-6"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCamera,
    className: "w-5 text-gray-300"
  }), /*#__PURE__*/React.createElement("p", {
    className: "uppercase text-teal-400 text-md"
  }, t("upload_scan_guidelines"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Carousel, {
    className: "h-full flex items-center justify-center",
    showStatus: false,
    showArrows: false,
    showThumbs: false,
    autoPlay: true,
    interval: 3000,
    infiniteLoop: true,
    swipeable: true
  }, carouselImages.map(function (img, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "pb-6"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-gray-800 border flex justify-center py-24 border-gray-700 rounded-md px-6 "
    }, /*#__PURE__*/React.createElement(Image, {
      src: img === null || img === void 0 ? void 0 : img.src,
      width: 240,
      height: 172,
      alt: img === null || img === void 0 ? void 0 : img.src
    })), /*#__PURE__*/React.createElement("p", {
      className: "text-center py-6 text-base"
    }, t(img === null || img === void 0 ? void 0 : img.content)));
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classNames("flex w-full space-x-4 border-t-2 border-gray-800 py-4 px-6", {
      "bg-gray-900 !border-t !border-gray-700": isGuidelineActive,
      "!mb-3": isWebView()
    })
  }, /*#__PURE__*/React.createElement(Button, {
    className: "w-1/2 py-4 px-6",
    onClick: function onClick() {
      isGuidelineActive ? setIsGuidelineActive(false) : onClose();
    }
  }, t("back_key")), /*#__PURE__*/React.createElement(Button, {
    isPrimary: true,
    className: "w-1/2 space-x-4 flex py-4 px-6",
    onClick: onAddFile
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCamera
  }), /*#__PURE__*/React.createElement("p", {
    className: "whitespace-nowrap"
  }, t("capture_scan")))));
}
export default GuidelineModal;